import React from 'react';
import { arrayOf, shape, string } from 'prop-types';

import IconBuilder from '../icon-builder';

const RebatesPill = ({ pill }) => {
  if (!pill?.text) {
    return null;
  }

  return (
    <div aria-label={pill?.accessibility_text} className="content-label">
      <p>
        <span className="rebates-pill">
          {pill?.values && IconBuilder.ic_coupon}
          {pill.text}
        </span>
      </p>
    </div>
  );
};

RebatesPill.propTypes = {
  pill: shape({
    accessibility_text: string,
    text: string,
    values: arrayOf(
      shape({
        id: string,
      }),
    ),
  }),
};

export default RebatesPill;
